"use client";

import Button from "@/components/ui/Button";
import Link from "next/link";
import { useAuth } from "@/hooks/useAuth";

const basicFeatures = [
  "Eingabe grundlegender Unternehmensdaten",
  "Analyse des Status Quo",
  "Übersicht zentraler Kennzahlen (CO₂, Kosten, Distanz)",
  "Zugriff auf Maßnahmenkatalog",
  "Erste Orientierung zu Verbesserungspotenzialen",
];

const expertFeatures = [
  "Detaillierte Dateneingabe (Arbeitsmodelle, Fuhrpark, etc.)",
  "Erweiterte Analyse der betrieblichen Mobilität",
  "Szenariovergleich (Status Quo vs. Maßnahmen)",
  "Quantifizierung von Effekten (Kosten, CO₂, Modal Split)",
  "Fundierte Entscheidungsgrundlage",
];

export default function PricingCards() {
  const { isAuthenticated, isExpert, loginWithRedirect } = useAuth();

  return (
    <section className="w-full px-4 py-16 sm:px-6 lg:px-8 2xl:px-16">
      <div className="flex flex-col gap-2 mb-10">
        <h2 className="text-3xl font-bold text-gray-900">Überblick</h2>
        <p className="text-sm text-gray-500">Zwei Wege zur Analyse Ihrer Mobilität</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* Basic */}
        <div className="rounded-xl border border-gray-200 bg-white p-6 flex flex-col gap-4">
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">BASIC</p>
            <p className="text-sm text-gray-500">Kostenlos starten</p>
          </div>
          <div className="text-5xl font-bold text-gray-900">gratis</div>
          <ul className="flex flex-col gap-2 flex-1">
            {basicFeatures.map((feature) => (
              <li key={feature} className="flex items-start gap-2 text-sm text-gray-600">
                <span className="text-green-500 mt-0.5">✓</span>
                {feature}
              </li>
            ))}
          </ul>
          <Link href="/willkommen">
            <Button fullWidth>
              {isAuthenticated ? "Tool starten" : "Kostenlos starten"}
            </Button>
          </Link>
        </div>

        {/* Expert */}
        <div className={`rounded-xl border bg-white p-6 flex flex-col gap-4 ${isExpert ? "border-blue-600" : "border-gray-200"}`}>
          <div className="flex items-start justify-between">
            <div>
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Expert</p>
              <p className="text-sm text-gray-500">Erweiterte Analyse</p>
            </div>
            {isExpert && (
              <span className="text-xs font-semibold bg-blue-100 text-blue-700 px-2.5 py-1 rounded-full">
                Ihr Plan
              </span>
            )}
          </div>
          <div className="flex items-baseline gap-1">
            <span className="text-5xl font-bold text-gray-900">10€</span>
            <span className="text-sm text-gray-500">/ Monat</span>
          </div>
          <ul className="flex flex-col gap-2 flex-1">
            {expertFeatures.map((feature) => (
              <li key={feature} className="flex items-start gap-2 text-sm text-gray-600">
                <span className="text-green-500 mt-0.5">✓</span>
                {feature}
              </li>
            ))}
          </ul>
          {isExpert ? (
            <Link href="/willkommen">
              <Button fullWidth>Tool starten</Button>
            </Link>
          ) : isAuthenticated ? (
            <Link href="/upgrade">
              <Button variant="outline" fullWidth>Jetzt upgraden</Button>
            </Link>
          ) : (
            <Button variant="outline" fullWidth onClick={() => loginWithRedirect("/upgrade")}>
              Registrieren & upgraden
            </Button>
          )}
        </div>

      </div>
    </section>
  );
}
